<template>
  <div class = "afdc-form-group">
    <label class="afdc-sr-only" for="afdc-state-select">{{ $t('States') }}</label>
    <select class ="afdc-custom-select" id="afdc-state-select" v-model="selectedState">
      <option value="all">
        All states
      </option>
      <option v-for="state in states" v-bind:key="state.abbreviation" v-bind:value="state">
        {{state.name}}
      </option>
    </select>
  </div>
</template>

<script>
import stateObj from '@/lib/states';

export default {
  name: 'StateFilter',

  data() {
    return {
      states: {},
      selectedState: 'all',
    };
  },
  watch: {
    selectedState(newVal) {
      if (newVal !== 'all') {
        this.$store.commit('setCorridorState', newVal);
      } else {
        this.$store.commit('setCorridorState', {});
      }
    },
  },

  mounted() {
    const oldStateObj = stateObj;
    const newStateObj = [];
    oldStateObj.features.forEach((state) => newStateObj.push({
      name: state.properties.name,
      abbreviation: state.properties.state_code,
      geometry: state.geometry,
    }));
    this.states = newStateObj;
    // newStateObj = this.states;
  },

};

</script>
